export default __webpack_public_path__ + "static/media/515.10c366f9.png";